import { render, staticRenderFns } from "./EnterNewSpis.vue?vue&type=template&id=0e7e12e1"
import script from "./EnterNewSpis.vue?vue&type=script&lang=js"
export * from "./EnterNewSpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports